module.exports = __webpack_public_path__ + "static/Grafika1@2x-6a54d8b355b1d7cac2449897b3766520.png";